var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSpeaker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5554 56.9959L36.5068 74.4539C37.804 77.36 36.4996 80.7642 33.5936 82.0613C30.6875 83.3585 27.2833 82.0542 25.9861 79.1481L11.0186 46.0488",
    stroke: "url(#paint0_linear_171_991)",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.333 64.4993L28.6663 46.5827H14.333C8.39542 46.5827 3.58301 41.7703 3.58301 35.8327C3.58301 29.8951 8.39542 25.0827 14.333 25.0827H28.6663L57.333 7.16602V64.4993Z",
    stroke: "url(#paint1_linear_171_991)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.25 35.832H82.4167",
    stroke: "url(#paint2_linear_171_991)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9277 19.7083L77.1341 16.125",
    stroke: "url(#paint3_linear_171_991)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9277 51.957L77.1341 55.5404",
    stroke: "url(#paint4_linear_171_991)",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_171_991",
    x1: 43.4465,
    y1: 82.5611,
    x2: 12.2108,
    y2: 82.5611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E03694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47253"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_171_991",
    x1: 70.6472,
    y1: 64.4961,
    x2: 6.0486,
    y2: 64.4961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E03694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47253"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_171_991",
    x1: 84.1919,
    y1: 36.832,
    x2: 75.5787,
    y2: 36.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E03694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47253"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_171_991",
    x1: 78.6714,
    y1: 19.7081,
    x2: 71.2124,
    y2: 19.7081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E03694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47253"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_171_991",
    x1: 78.6714,
    y1: 55.5402,
    x2: 71.2124,
    y2: 55.5402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E03694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47253"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSpeaker);
export default __webpack_public_path__ + "static/media/ic-speaker.5557b5d9ce94ec73c5067b8ab781bf50.svg";
export { ForwardRef as ReactComponent };